const ESC_MAP = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
}

export function escapeHtml(s, forAttribute) {
    return s.replace(forAttribute ? /[&<>'"]/g : /[<>]/g, function (c) {
        return ESC_MAP[c]
    })
}

export function decodeHTML(s) {
    if (!s) return s;
    const div = document.createElement('div');
    div.innerHTML = s;
    return div.textContent || div.innerText || '';
}